export default {"src":"/_next/static/media/2.7c4714b6.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};